// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".ed46e7b6f61b268e21d2a5728341ab2b.js";
};